import React, { useEffect, useState } from "react";
import { db, collection, getDocs } from "../firebase";

function PageCarousel({ collectionName }) {
  const [carouselItems, setCarouselItems] = useState([]);

  useEffect(() => {
    const fetchCarouselData = async () => {
      if (!collectionName) return;
      try {
        const querySnapshot = await getDocs(collection(db, collectionName));
        const data = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setCarouselItems(data);
      } catch (error) {
        console.error("Error fetching carousel data:", error);
      }
    };

    fetchCarouselData();
  }, [collectionName]);

  return (
    <div>
      <div
        id="carousel"
        className="carousel pages_carousel carousel2 slide"
        data-ride="carousel"
      >
        {/* Carousel Items */}
        {carouselItems.map((item, index) => (
          <div
            className={`carousel-item ${index === 0 ? "active" : ""}`}
            key={item.id}
          >
            <img src={item.imageUrl} alt="Carousel Image" />
          </div>
        ))}
      </div>
    </div>
  );
}

export default PageCarousel;
